/* tslint:disable */

declare var Object: any;
export interface EncuestaRespuestasInterface {
  "id": number;
  "encuestaId": number;
  "sucursalId": number;
  "fechaHora"?: Date;
}

export class EncuestaRespuestas implements EncuestaRespuestasInterface {
  "id": number;
  "encuestaId": number;
  "sucursalId": number;
  "fechaHora": Date;
  constructor(data?: EncuestaRespuestasInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EncuestaRespuestas`.
   */
  public static getModelName() {
    return "EncuestaRespuestas";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EncuestaRespuestas for dynamic purposes.
  **/
  public static factory(data: EncuestaRespuestasInterface): EncuestaRespuestas{
    return new EncuestaRespuestas(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EncuestaRespuestas',
      plural: 'EncuestaRespuestas',
      path: 'EncuestaRespuestas',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "encuestaId": {
          name: 'encuestaId',
          type: 'number'
        },
        "sucursalId": {
          name: 'sucursalId',
          type: 'number'
        },
        "fechaHora": {
          name: 'fechaHora',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/EncuestaRespuestas.ts